<template>
  <div class="reset" >
    <el-header style="margin-top:26px;">
      <img
        class="logo"
        src="../assets/logo.svg">
      <!-- <p>{{$t('global.parentTitle')}}</p> -->
    </el-header>
    <!-- 重置密码 -->
      <div class="reset_form" v-if="isreset">
        <p @click="back()" class="fhaaa"><i class="icon el-icon-arrow-left"></i>{{$t('global.back')}}</p>
        <el-form :model="resetForm" :rules="resetValidate" ref="resetForm" label-width="100px" class="demo-resetForm">
          <h3>{{$t('header.resetPassword')}}</h3>
          <p v-if="isShow">{{$t('login.currentPassword')}}</p>
          <el-form-item prop="currentPassword" v-if="isShow">
            <el-input :class="changeCurrentFlag == 1?'':'errorPass'" :type="resetForm.currentPwdType" v-model="resetForm.currentPassword" autocomplete="off"></el-input>
            <img :src="resetForm.currentSeen?openeye:nopeneye" class="eye" alt="" @click="changeType('currentSeen')">
          </el-form-item>
          <p v-if="isShow">{{$t('login.newPassword')}}</p>
          <p v-else>{{$t('login.enterPassword')}}</p>
            <el-form-item prop="newPassword">
              <el-input :class="changeFlag == 1?'':'errorPass'" :type="resetForm.newPwdType" v-model="resetForm.newPassword" autocomplete="off"></el-input>
              <img :src="resetForm.NewSeen?openeye:nopeneye" class="eye" alt="" @click="changeType('NewSeen')">
            </el-form-item>
          <p v-if="isShow">{{$t('login.confirmNewPassword')}}</p>
          <p v-else>{{$t('login.confirmPassword')}}</p>
          <el-form-item prop="ConfirmNewPassword">
            <el-input :class="changeAgainFlag == 1?'':'errorPass'" :type="resetForm.confirmNewPwdType" v-model="resetForm.ConfirmNewPassword" autocomplete="off"></el-input>
            <img :src="resetForm.confirmNewSeen?openeye:nopeneye" class="eye" alt="" @click="changeType('confirmNewSeen')">
          </el-form-item>
          <el-button type="primary" @click="toReset()">{{$t('login.reset')}}</el-button>
        </el-form>
      </div>
      <!-- savePass -->
      <div class="save_form" v-if="issave">
        <!-- <el-header>
          <img
            class="logo"
            src="../assets/logo.svg">
          <p>{{$t('global.parentTitle')}}</p>
        </el-header> -->
        <el-form label-width="100px" class="demo-forgetForm">
        <h3>{{$t('login.savedPsw')}}</h3>
        <p
          class="huo"
          @click="ToSign"
          >{{$t('login.backSign')}}</p>
        </el-form>
      </div>
  </div>
</template>
<script>
import { getStore, keys } from '@/store';
export default {
  name: 'resetPassword',
  data () {
    // 原密码
    const currentpwdCheck = async (rule, value, callback) => {
      // let reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~@#$%\*-\+=:,\\?\[\]\{}]).{6,16}$/
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/
      if (value.length < 1) {
        this.changeCurrentFlag = 2
        return callback(new Error(this.$t('errorprompt.currentpswEmpty')))
      // } else if (value.length > 16) {
      //   // this.changeFlag = 2;
      //   return callback(new Error('密码最长不能超过16位！'));
      } else if (!reg.test(value)) {
        this.changeCurrentFlag = 2
        return callback(new Error(this.$t('errorprompt.passwordLessThan')))
      } else if (this.resetForm.newPassword == this.resetForm.currentPassword) {
        this.changeCurrentFlag = 2
        return callback(new Error(this.$t('errorprompt.newPswSameAs')))
      } else {
        this.changeCurrentFlag = 1
        callback()
      }
    }
    // 密码验证
    const pwdCheck = async (rule, value, callback) => {
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/
      if (value.length < 1) {
        this.changeFlag = 2
        return callback(new Error(this.$t('errorprompt.newPswEmpty')))
      // } else if (value.length < 8) {
        // this.changeFlag = 2;
        // return callback(new Error('New password cannot be less than 8 digits'));
      // } else if (value.length > 16) {
      //   // this.changeFlag = 2;
      //   return callback(new Error('密码最长不能超过16位！'));
      } else if (!reg.test(value)) {
        this.changeFlag = 2
        return callback(new Error(this.$t('errorprompt.passwordLessThan')))
      } else if (this.resetForm.newPassword == this.resetForm.currentPassword) {
        this.changeFlag = 2
        return callback(new Error(this.$t('errorprompt.newPswSameAs')))
      } else {
        this.changeFlag = 1
        callback()
      }
    }
    // 重复密码验证
    const pwdAgainCheck = async (rule, value, callback) => {
      if (value.length < 1) {
        this.changeAgainFlag = 2
        return callback(new Error(this.$t('errorprompt.newPswEmpty')))
      } else if (this.resetForm.newPassword != this.resetForm.ConfirmNewPassword) {
        this.changeAgainFlag = 2
        return callback(new Error(this.$t('errorprompt.newPswDontSame')))
      } else {
        this.changeAgainFlag = 1
        callback()
      }
    }
    return {
      resetForm: {
        currentPassword: '',
        newPassword: '',
        ConfirmNewPassword: '',
        NewSeen: false,
        currentSeen: false,
        confirmNewSeen: false,
        currentPwdType: 'password',
        newPwdType: 'password',
        confirmNewPwdType: 'password'
      },
      resetValidate: {
        currentPassword: [
          { required: true, validator: currentpwdCheck, trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: pwdCheck, trigger: 'blur' }
        ],
        ConfirmNewPassword: [
          { required: true, validator: pwdAgainCheck, trigger: 'blur' }
        ]
      },
      changeCurrentFlag: 1,
      changeFlag: 1,
      changeAgainFlag: 1,
      openeye: require('@/assets/eye.svg'), // 图片地址
      nopeneye: require('@/assets/eye-off.svg'), // 图片地址
      isreset: true,
      issave: false,
      isShow: false
    }
  },
  created () {
    if (getStore(keys.token)) {
      if (getStore(keys.userInfo).status == 0) {
        this.$router.push({
          path: '/email'
        })
      }
    } else {
      this.$router.push({
        path: '/'
      })
    }
    if (this.$route.query.type == 1) {
      this.isShow = true
    } else if (this.$route.query.type == 0) {
      this.isShow = false
    }
  },
  methods: {
    changeType (seen) {
      if (seen == 'currentSeen') {
        this.resetForm.currentPwdType = this.resetForm.currentPwdType === 'password' ? 'text' : 'password'
        this.resetForm.currentSeen = !this.resetForm.currentSeen
      } else if (seen == 'NewSeen') {
        this.resetForm.newPwdType = this.resetForm.newPwdType === 'password' ? 'text' : 'password'
        this.resetForm.NewSeen = !this.resetForm.NewSeen
      } else if (seen == 'confirmNewSeen') {
        this.resetForm.confirmNewPwdType = this.resetForm.confirmNewPwdType === 'password' ? 'text' : 'password'
        this.resetForm.confirmNewSeen = !this.resetForm.confirmNewSeen
      }
    },
    ToSign () {
      this.$router.push({ path: '/loginPassword' })
    },
    back () {
      // if (window.history.length <= 1) {
      this.$router.push({ path: '/home/children/information' })
      // return false;
      // } else {
      // this.$router.go(-1);
      // }
    },
    toReset () {
      // 进行表单验证

      if (this.$route.query.type == 1) {
        this.$refs.resetForm.validate((valid, msg) => {
          if (!valid) {
            this.$message(msg['currentPassword'][0].message || msg['newPassword'][0].message || msg['ConfirmNewPassword'][0].message)
            return false
          }
          this.$http.post('/api/user/password', {
            old_pwd: this.resetForm.currentPassword,
            new_pwd: this.resetForm.newPassword,
            _method: 'PUT'
          }).then((res) => {
            if (res.data.code == 200) {
              console.log(res)
              this.issave = !this.issave
              this.isreset = !this.isreset
              this.$message({
                message: res.data.msg,
                type: 'success'
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
            }
          }).catch((error) => {
            console.log(error) // 请求失败返回的数据
          })
        })
      } else if (this.$route.query.type == 0) {
        this.$refs.resetForm.validate((valid, msg) => {
          if (!valid) {
            this.$message(msg['newPassword'][0].message || msg['ConfirmNewPassword'][0].message)
            return false
          }
          this.$http.post('/api/setPassword', {
            password: this.resetForm.newPassword
          }).then((res) => {
            if (res.data.code == 200) {
              console.log(res)
              this.issave = !this.issave
              this.isreset = !this.isreset
              this.$message({
                message: res.data.msg,
                type: 'success'
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
            }
          }).catch((error) => {
            console.log(error) // 请求失败返回的数据
          })
        })
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.reset{
    width: 1200px;
    height:auto!important;
    margin: 0 auto;
    p{
      font-size: 16px;
      font-family: Sofia Pro-Regular;
      color: #424347;
    }
    h3{
      font-size: 30px;
      font-family: Sofia Pro-Bold;
      font-weight: 700;
      color: #353643;
      // margin-top:40px;
      margin: 70px auto 0 auto;
      width: 600px;

    }

    .huo {
      font-size: 18px;
      font-family: Sofia Pro-Bold;
      font-weight: 700;
      text-decoration: underline;
      text-align: LEFT;
      color: #4B69FE;
      cursor: pointer;
      // margin-top:40px;
      display: block;
      width: 600px;
      margin: 40px auto 0 auto;
    }
    .save_form{
      .el-form{
        margin-left: 90px;
      }
      .el-header{
          width: 1200px;
          height:auto!important;
          padding: 20px 0;
          font-family: Sofia Pro-Regular;
          font-size: 24px;
          font-weight: 400;
          text-align: left;
          color: #353643;
          .logo {
            width: 309px;
            height: 69px;
            img{
              width:100%;
              height:100%;
            }
          }
          p {
            width: 309px;
            margin-top:10px;
            text-align: center;
          }
      }
    }
    .reset_form{
      width:385px;
      // margin-top:70px;
      margin: 0 auto 0 auto;
        // margin-left: 90px;
        .el-form {
        width: 100%;
        // margin-top: 30px;
        // margin-left: 90px;
        /deep/ .el-form-item{
              margin-bottom:30px;
            .el-form-item__content{
              display: flex;
              margin:0!important;
              img{
                width: 20px;
                height:20px;
                margin: 0 10px;
                position: absolute;
                right: 0px;
                bottom:12px;
              }
              .el-input{
                border-bottom: 1px solid #a5a5a5;
              }
              .errorPass{
                border-bottom: 1px solid #fc424c;
              }
              .el-input__inner {
                -moz-appearance: none;
                width:100%;
                height: 40px;
                border:none;
                background: none;
                font-size: 16px;
                color: #353643;
                font-family: Sofia Pro-Regular;
                letter-spacing: 0px;
                outline: 0;
                padding:0 40px 0 0;
                border-radius: 0;
              }
              .el-form-item__error{
                // margin-top:7px;
                font-size: 14px;
                color: #fc424c;
                font-family: Sofia Pro-Regular;
                width: max-content;
              }
            }
          }
        .password_look_list{
          width: 100%;
          display: flex;
          border-bottom: 1px solid #a5a5a5;
          img{
            width: 24px;
            height:24px;
            margin: 0 10px;
          }
        }
        button{
          width: 214px;
          height: 50px;
          left: 515px;
          bottom: 193px;
          border:1px solid #4B69FE;
          background: #4B69FE;
          border-radius: 50px;
          font-size: 18px;
          // width: 190px;
          // height: 40px;
          // background: #ff6440;
          // border-radius: 4px;
          // border:1px solid #ff6440;
          // margin-top: 40px;
          // color:#fff;
          // font-size: 16px;
          // font-family: Sofia Pro-Bold;
          // box-shadow: 0px 1px 6px 1px rgba(81,124,255,0.20), 0px 1px 6px 1px rgba(81,124,255,0.20);
        }
        .borderBtn{
            width:auto;
            height: 40px;
            background: #ffffff;
            border: 2px solid #ff6440;
            border-radius: 7px;
            font-size: 14px;
            font-family: Sofia Pro-Bold;
            font-weight: 700;
            color: #ff6440;
            margin: 0 20px;
            &:hover{
              background: #ffffff;
              border: 2px solid #ff6440;
              font-size: 14px;
              font-family: Sofia Pro-Bold;
              font-weight: 700;
              color: #ff6440;
            }
        }
        p{
          margin-top:30px;
        }
        input{
          width:345px;
          height: 50px;
          border:none;
          background: none;
          font-size: 18px;
          color: #353643;
          font-family: Sofia Pro-Regular;
          letter-spacing: 0px;
        }
        input:focus {
          outline: none;
        }
      }
    }
}
      .logo {
        width: 227px;
        height: 50px;
        img{
          width:100%;
          height:100%;
        }
      }
      .fhaaa{
            position: relative;
            left: -125px;
            font-weight: bold;
      }
</style>



// WEBPACK FOOTER //
// src/components/resetPassword.vue